export const escape_ending = [
  '*beep boop* ALERT! ALERT! <Lümmel detected> initiate emergencyexit.exe',
  'Chat wurde fluchtartig beendet.'
];
